import React, { useEffect, useState } from "react";
import AppBar from "components/Layout/AppBar";
import { Select, Space } from 'antd';
import Box from "@mui/material/Box";
import { useStore } from "_Store";
import MenuItem from '@mui/material/MenuItem';
import { getStockDetails as gStockDetails, getSeed , getStockPdf} from "services/stock.service";
import moment from "moment";
import { useTable } from 'react-table'
import DropDownIcon from "assets/img/dropdowncircule.svg";
import { request } from "services/api";
import NoStockOrNoCampaign from "./StockTabs/NoStockOrCampaign";
import FermeNo1 from "./StockTabs/FermeNo1";
import styled from 'styled-components'
import { Loading } from "components/Ui";
import TopHeadBox from "components/Ui/TopHeadBox";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import { useExportData } from "react-table-plugins";
import * as XLSX from 'xlsx';
import JsPDF from "jspdf";
import "jspdf-autotable";
import fr from 'date-fns/locale/fr';
import Button from "@mui/material/Button";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import selectOption from "assets/mock/selectEntries.json";
//import UnstyledSelectsMultiple from 'components/Ui/MultiSelect'
import Multiselect from 'multiselect-react-dropdown';
import useSeedData from "hooks/useSeedData";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import InitialStock from './components/InitialStock';
registerLocale('fr', fr)

function formatDate(date) {
  return moment(new Date(date)).format("DD-MM-yyyy");
}
function getExportFileBlob({ columns, data, fileType, fileName }) {
  if (fileType === "csv") {
    // CSV example
    const headerNames = columns.map((col) => col.exportValue);
    const csvString = Papa.unparse({ fields: headerNames, data });
    return new Blob([csvString], { type: "text/csv" });
  } else if (fileType === "xlsx") {
    // XLSX example

    const header = columns.map((column) =>{ 
      let value=column.exportValue;
      if(column.parent) value= value+` ${column.parent.Header}`;
      return value
     });
    const compatibleData = data.map((row) => {
      const obj = {};
      header.forEach((col, index) => {
        obj[col] = row[index];
      });
      return obj;
    });

    let wb = XLSX.utils.book_new();
    let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
      header,
    });
    XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
    XLSX.writeFile(wb, `${fileName}.xlsx`);

    // Returning false as downloading of file is already taken care of
    return false;
  }
  //PDF example
  if (fileType === "pdf") {
    const headerNames = columns.map((column) =>{ 
     let value=column.exportValue;
     if(column.parent) value= value+` ${column.parent.Header}`;
     return value
    });
    const doc = new JsPDF({format: 'a4', orientation: 'landscape', unit: 'cm'});
    // Define the coordinates where you want to place the image
      var x = 0;
      var y = 0;

      // Load the image
      var img = new Image();
      img.src = location.origin + "/images/logo.jpeg";
      img.onload = function() {
        // Get the original dimensions of the image
        var width = img.width;
        var height = img.height;
        // Calculate the height that corresponds to a width of 236 pixels
        var newHeight = (236 / width) * height;
        // Add the image to the PDF with the new width and height
        doc.addImage(img, 'JPEG', x, y, 236, newHeight);
};

    doc.autoTable({
      headStyles:{fillColor: [16, 135, 88],minCellHeight: 1},
      head: [headerNames],
      body: data,
      margin: { to: 20 },
      theme: "striped",
      showHead: "everyPage",
      styles: {
        overflow: "linebreak",
        minCellHeight: 2,
        cellWidth:"auto",
        halign: "left",
        valign: "center",
        fontSize: 8,
      },
      startY: 0.5,
      didParseCell: function (data) {
        if (data.row.index === 0 && data.column.index === 0) {
          data.cell.text = 'Rapport de Stock';
        }
      }
    });
    doc.save(`${fileName}.pdf`);

    return false;
  }

  // Other formats goes here
  return false;
}
function makeData(stocks) {
  let newData = [];
  if (stocks && stocks.length > 0) {
    for (const details of stocks) {
      let productName='';
      let productUnite='';
      switch(details.productType){
        case 'semence' :
          productName=details?.seedVarietyData?.name;
          productUnite=details?.seedVarietyData?.unite;
          if(details && !details.seedVarietyData){
            productName=details?.seedData?.seedName;
            productUnite=details?.seedData?.seedUnite;
          }
          break;
        case 'phyto' :
          productName=details?.phytoProductData?.name;
          productUnite=details?.phytoProductData?.unite;
          break;
        case 'intrant' :
          productName=details?.fertilizerData?.name;
          productUnite=details?.fertilizerData?.unite;
          break;
        default:
          productName=details?.seedData?.seedName;
          productUnite=details?.seedData?.seedUnite;
          break;
      }
      let entrees = { e_qty: "N/A", e_amount: "N/A", e_details: "N/A", };
      if (details.type === "ENTRIES") {
        entrees = {
          e_qty: (details.typeData.amount)+" "+productUnite,
          e_amount: (details.typeData.amount * details.typeData.unitPrice) + " CFA",
          e_details: "-",// "details.typeData?.transactionData?.type?.replace("_"," ")",
          stock: details.remainStock ? details.remainStock+" "+productUnite : "N/A"
        }
      }
      let sorties = { s_qty: "N/A", s_amount: "N/A", s_details: "N/A" };
      if (details.type === "EXITS") {
        sorties = {
          s_qty: (details.typeData.amount)+" "+productUnite,
          s_amount: (details.typeData.amount * details.typeData.unitPrice) + " CFA",
          s_details: details.typeData?.transactionData?.type?.replace("_"," "),
          stock: details.remainStock ? details.remainStock+" "+productUnite : "N/A"
        }
      }
    
      newData.push({
        date: formatDate(details.dateStock),
        seed: productName,
        productType: details.productType,
        pu: details.typeData.unitPrice + " CFA",
        transaction: details.type,
        ...entrees,
        ...sorties
      })
    }
  }
  return newData;
}
const StockSheet = () => {
  const {
    state: {
      activeCampaign,
      activeFarm
    },
  } = useStore();
const { data: seedList } = useSeedData();
  const [tabIndex, setTabIndex] = useState(activeFarm.id);
  const [date, setDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [persistedStockData, setPersistedStockData] = useState([]);
  const [stockData, setStockData] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [currentFarmHasCampaign, setCurrentFarmHasCampaign] = useState(false);
  const [resize, setResize] = React.useState(0);
  const [availableSeeds, setAvailableSeed] = React.useState([]);
  const [availableProductType, setAvailableProductType] = React.useState([
    {name:'culture',value:'culture'},
    {name:'intrant',value:'intrant'},
    {name:'semence',value:'semence'},
    {name:'produit phyto', value:'phyto'}
  ]);
  const [selectedSeed, setSelectedSeeds] = React.useState("");
  const [selectedFertilizer, setSelectedFertilizer] = React.useState("");
  const [selectedSeedVariety, setSelectedSeedVariety] = React.useState("");
  const [selectedPhytoProduct, setSelectedPhytoProduct] = React.useState("");
  const [selectedProductType, setSelectedProductType] = React.useState("");
  const [availableFinalities, setAvailableFinalities] = React.useState(selectOption);
  const [selectedFinality, setFinality] = React.useState([]);
  const [seeds, setSeeds] = React.useState([]);
  const [filter, setFilter] = React.useState(false);
  const [disabledGenratorButton, setDisabledGenratorButton] = React.useState(false);
  const [stockeInititationVisible, setStockeInititationVisible] = React.useState(false);
  const [fertilizerDatas, setFertilizerData] = React.useState([]);
  const [seedVarietyDatas, setSeedVarietyData] = React.useState([]);
  const [phytoDatas, setPhytoData] = React.useState([]);
  const [filterProductTypeSelecter, showFilterProductType] = React.useState('culture');

  const columns = React.useMemo(
    () => [
      {
        Header: 'Date',
        accessor: 'date',
      },
      {
        Header: 'Type de produit',
        accessor: 'productType',
      },
       {
        Header: 'Produit',
        accessor: 'seed',
      },
      {
        Header: 'Prix Unitaire',
        accessor: 'pu',
      },
      {
        Header: "Entrées",
        accessor: 'entries',
        columns: [
          {
            Header: 'Quantité',
            accessor: 'e_qty',
          },
          {
            Header: 'Montant',
            accessor: 'e_amount',
          },
          {
            Header: 'Details',
            accessor: 'e_details',
          },

        ],

      },
      {
        Header: "Sorties",
        accessor: 'sortie',
        columns: [
          {
            Header: 'Quantité',
            accessor: 's_qty',
          },
          {
            Header: 'Montant',
            accessor: 's_amount',
          },
          {
            Header: 'Details',
            accessor: 's_details',
          },

        ],
      },
      {
        Header: 'Stock Restant',
        accessor: 'stock',
      },

    ],
    []
  )
 const Table = ({ columns, data, reference,activeFarmData, activeCampaignData }) => {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    exportData,
  } = useTable({
    columns,
    data,
    getExportFileBlob
  },useExportData)

  // Render the UI for your table
  return (
   <div>
      <Button style={{ marginBottom:"20px",marginRight:"10px" }}
          size="small"
          variant="outlined"
          disabled={disabledGenratorButton}
          loading={disabledGenratorButton}
          startIcon={<PrintOutlinedIcon />}
          onClick={filterAndGetGeneratedPdf}>Rapport de stock PDF</Button>
     <Button style={{ marginBottom:"20px" }}
          size="small"
          variant="outlined"
          startIcon={<NoteAddIcon />}
          onClick={
            ()=>exportData("xlsx", false, `${activeFarmData?.farmName}_${activeCampaignData.season==='GREAT' ? 'grande_saison' : 'petite_saison' }_${new Date().getFullYear()}`)
             }>Rapport de stock EXCEL</Button>
     <table ref={reference} {...getTableProps()} className="table_ table_stock">
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()} className="tr_head">
            {headerGroup.headers.map((column) => {
              return <th {...column.getHeaderProps()}>{column.render('Header')}</th>
            })}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <tr {...row.getRowProps()} className="tr_" style={{ background: row.original.transaction === "ENTRIES" ? "antiquewhite" : "#e9b4b4" }}>
              {row.cells.map(cell => {

                return <td style={{ background: row.original.transaction === "ENTRIES" ? "antiquewhite" : "#e9b4b4" }} className="td_" {...cell.getCellProps()}>{cell.render('Cell')}</td>

              })}
            </tr>
          )
        })}
      </tbody>
    </table>
    </div>
  )
}
  const Styles = styled.div`
  overflow-y:auto;
  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`
const getStokData = () =>{
  setIsLoading(true)
  if(startDate ===null || endDate ===null){
    gStockDetails(activeCampaign.id).then((data) => {
      for (let i = 0; i < data.data['data'].length; i++) {
        data.data['data'][i]['farmIdOnly'] = data.data['data'][i]['farmId'];
        data.data['data'][i]['farmName'] = activeFarm.farmName;

        data.data['data'][i]['farmId'] = "Exploitatatin Agricole N°" + data.data['data'][i]['farmId'];
      }
      setPersistedStockData(data.data['data']);
      setIsLoading(false)
      setStockData(data.data['data']);
    });
  }else{
    gStockDetails(activeCampaign.id,startDate,endDate).then((data) => {
      for (let i = 0; i < data.data['data'].length; i++) {
        data.data['data'][i]['farmIdOnly'] = data.data['data'][i]['farmId'];
        data.data['data'][i]['farmName'] = activeFarm.farmName;
        data.data['data'][i]['farmId'] = "Exploitatatin Agricole N°" + data.data['data'][i]['farmId'];
      }
      setPersistedStockData(data.data['data']);
      setIsLoading(false)
      setStockData(data.data['data']);
    });
}
}

  useEffect(() => {
    getSeedData();
    getStokData()
  }, [])

  useEffect(() => {
    getStokData()
  }, [endDate])

  const filterCampaignOnFarm = async (farmId) => {
    setIsLoading(true)
    const response = await request.get(
      `/campaign/getCampaign?farmId=${farmId}`
    );

    if (response.data.success) {
      if (response.data.data.length > 0) {
        setIsLoading(false)
        return setCurrentFarmHasCampaign(true)
      }else{
        setIsLoading(false);
      }
      return setCurrentFarmHasCampaign(false)
    }else{
      setIsLoading(false)
    }
  };

  /* const generatePdf = async (nb) => {
    setResize(nb);
   }; */
   const refrence = React.createRef();
   const tableRef = React.createRef();
  
  useEffect(() => {
    if (tabIndex) {
      filterCampaignOnFarm(tabIndex)
    }
  }, [tabIndex])

useEffect(() => {
  const products = activeCampaign.productsYouGrow;
    if (products && products.length > 0) {
      for(const prod of products){
        if(!prod.initialStockHasBeenSet){
          setStockeInititationVisible(true)
          break;
        }
      }
    }
    getFertilizerData()
    getPhytoData()
    getSeedVarieryData()
  }, [activeCampaign])

  function getFertilizerData(){
    let products = activeCampaign.fertilizerRequirement,
        data =[];
    if(products && products.length > 0){
       for(const product of products){
         let fertilizer = product;
         data=[...data,{id: fertilizer.id,name: fertilizer.type}];
       }
     }
     setFertilizerData(data)
   }

   function getPhytoData(){
    let products = activeCampaign.phytoProductRequirement,
        data =[];
    if(products && products.length > 0){
       for(const product of products){
         let phyto = product;
         data=[...data,{id: phyto.id,name: phyto.type}];
       }
     }
     setPhytoData(data)
   }

   function getSeedVarieryData(){
    let products = activeCampaign.seedRequirement,
        data =[];
    if(products && products.length > 0){
       for(const product of products){
         let seed = product;
         data=[...data,{id: seed.id,name: seed.type}];
       }
     }
     setSeedVarietyData(data)
   }

  function getFarmStockSheet(index) {
    return stockData.filter(el => el.farmIdOnly === index || el.farmId == index)
  }
  function TabPanel(props) {
    const { value, index, ...other } = props;

    return (
      <div ref={props.reference}
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <div className="mt-14">
            <Box
                  className="firstcreatCreer mb-5" style={{ marginTop: "0px" }}
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    placeItems: "left",
                    p: 2,

                    bgcolor: "background.paper",
                    borderRadius: 1,
                  }}
                >
                {
                  activeCampaign && activeCampaign.productsYouGrow && activeCampaign.productsYouGrow.length > 0 
                  ? activeCampaign.productsYouGrow.map((product)=>{
                      return <div style={{ marginRight:"20px" }}>
                      <p style={{ margin: "0", color: "#979797" }}>
                        {" "}
                        Stock Initial <strong>{product.seed.seedName} </strong>
                      </p>
                      <p
                        style={{
                          display: "flex",
                          margin: "0",
                          color: "#373737",
                        }}
                      >
                        {product.initialStock} {product.seed.seedUnite}
                        <img src={DropDownIcon} style={{ marginLeft: "5px" }} />
                      </p>
                    </div>
                  }) 
                  : null
                   }  
                </Box>
            <Styles>
              <Table activeFarmData={activeFarm} activeCampaignData={activeCampaign} reference={tableRef} columns={columns} data={makeData(getFarmStockSheet(index))}/>
            </Styles>
          </div>
        )}
      </div>
    );
  }

  function removeDuplicateJSONData(arr) {
    let seenIds = {};
    return arr.filter((item) => {
      if (seenIds[item.id]) {
        return false;
      } else {
        seenIds[item.id] = true;
        return true;
      }
    });
  }

  function getDataId(datas){
    let seds=[];
    if(datas && datas.length>0){
      seds= datas.map((s)=>(s.id))
    }
    return seds
  }

  function filterStockDataByAllFilter(){
    if(startDate ===null || endDate ===null){
    gStockDetails(activeCampaign.id).then((data) => {
      let datas=data.data.data;
      let stocks=datas.filter(el => el.farmId == activeFarm.id);
      if(selectedSeed && selectedSeed.length>0){
        let seids=getDataId(selectedSeed);
        stocks=stocks.filter((p)=>seids.indexOf(p.seed)>=0)
      }
      if(selectedFinality && selectedFinality.length>0){
          let seids=getDataId(selectedFinality);
          stocks=stocks.filter((p)=>{
           return seids.indexOf(p?.typeData?.destination)>=0
          })
      }
      setIsLoading(false)
      setStockData(stocks);
      setPersistedStockData(stocks);
    });
   }else{
    gStockDetails(activeCampaign.id,startDate,endDate).then((data) => {
      let datas=data.data.data
      let stocks=datas.filter(el => el.farmId == activeFarm.id);
      if(selectedSeed && selectedSeed.length>0){
        let seids=getDataId(selectedSeed);
        stocks=stocks.filter((p)=>seids.indexOf(p.seed)>=0)
      }
      if(selectedFinality && selectedFinality.length>0){
          let seids=getDataId(selectedFinality);
          stocks=stocks.filter((p)=>{
           return seids.indexOf(p?.typeData?.destination)>=0
          })
      }
      setIsLoading(false)
      setStockData(stocks);
      setPersistedStockData(stocks);
    });
  }
  }
  const downloadFile = (link) => {
    const anchor = document.createElement('a');
    anchor.href = link;
    anchor.target = "_blank";
    anchor.download = true;
    anchor.click();
  };
  function filterAndGetGeneratedPdf(){
    setDisabledGenratorButton(true)
    if(startDate ===null || endDate ===null){
      getStockPdf(activeCampaign.id).then((data) => {
        downloadFile(data.data.dataFileReturn.file)
        setDisabledGenratorButton(false)
    });
   }else{
    getStockPdf(activeCampaign.id,startDate,endDate).then((data) => {
      downloadFile(data.data.dataFileReturn.file)
      setDisabledGenratorButton(false)
    });
  }
  }

  useEffect(() => {
    setIsLoading(true)
    filterStockDataByAllFilter()
  }, [selectedFinality,selectedSeed])

  const handleSeedChange = (e) =>{
    setSelectedSeeds(e)
  }
  const handleSeedVarietyChange = (e) =>{
    setSelectedSeedVariety(e)
  }
  const handleFertilizerChange = (e) =>{
    setSelectedFertilizer(e)
  }
  const handlePhytoProductChange = (e) =>{
    setSelectedPhytoProduct(e)
  }
  
  const handleProductTypeChange = (e) =>{
    setSelectedProductType(e)
    showFilterProductType(e);
  }
  const handleFinalityChange = (e) =>{
    setFinality(e)
  }

  function getSeedData(){
    let products = activeCampaign.productsYouGrow,
        data =[];
    if(products && products.length > 0){
       for(const product of products){
         let seed = product.seed;
         data=[...data,{id: seed.id,name: seed.seedName}];
       }
     }
     setAvailableSeed(data)
   }
  return (
    <>
      <div className="w-full sm:max-w-screen-2xl sm:px-6 mx-auto flex flex-col">
        <div className="pt-4">
          <AppBar />
        </div>
        <div>
          <TopHeadBox  style={{width:"100%" }}/>
        </div>
        {isLoading ? <Loading/> : ""}
        <div>
          <Box
            sx={{ mt: 4 }}
          >
            <Box className="feremtabn" style={{ display:"inline-block",width:"100%" }}>
            <Box className="datepicbyyear mutliDateInput cachier_datepicker ml-0" style={{ display:"inline-block" }}>
            <Button style={{ marginBottom:"20px",marginRight:"10px" }}
                size="small"
                variant="outlined"
                color="info"
                startIcon={<FilterAltIcon />}
                onClick={()=>setFilter((!filter ? true : false))}> {filter ? "Fermer" : "Filtrer"}
            </Button>
            </Box>
            
              {
                (stockData?.length > 0) ?
                  <div className="creatbtn-redirect  ml-2 mr-2"  style={{ display:"inline-block",float:"right" }}>
                    <FermeNo1 />
                  </div> : "" 
              }
              
              {filter ? 
                      <Box sx={{ mt: 4 }} style={{ background:"#fff" }} className="p-4">
                        <Box className="datepicbyyear mutliDateInput cachier_datepicker ml-0" style={{ display:"inline-block" }}>
                                <DatePicker
                                style={{ width:"300px" }}
                                    locale="fr"
                                    selectsRange={true}
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={(update) => {
                                      setDateRange(update);
                                    }}
                                    placeholderText={"Trier par interval de Date"}
                                    isClearable={true}
                                  />
                        </Box>
                         <div className="creatbtn-redirect  ml-2 mr-2"  style={{ display:"inline-block" }}>
                            <Select
                              //style={{ height: '46px' }}
                              value={selectedProductType}
                              onChange={handleProductTypeChange}
                              displayEmpty
                            >
                              <MenuItem value="" disabled>
                                Trier par Type de produit
                              </MenuItem>
                              {availableProductType.map((data) => (
                                <MenuItem key={data.value} value={data.value}>
                                  {data.name}
                                </MenuItem>
                              ))}
                            </Select>
                                     {/*  <Multiselect
                                        options={availableProductType} // Options to display in the dropdown
                                        selectedValues={selectedProductType} // Preselected value to persist in dropdown
                                        onSelect={handleProductTypeChange} // Function will trigger on select event
                                        onRemove={handleProductTypeChange} // Function will trigger on remove event
                                        displayValue="name" // Property name to display in the dropdown options
                                        emptyRecordMsg="Aucune option trouvée"
                                        placeholder="Type de produit"
                                        style={{
                                          option: {  color: "black" },
                                          chips: { background: "#108758" },
                                          selected: { background: "#108758" },
                                        }}
                                        /> */}
                        </div>
                        { filterProductTypeSelecter==='culture' ? 
                          <div className="creatbtn-redirect  ml-2 mr-2"  style={{ display:"inline-block" }}>
                                        <Multiselect
                                          options={removeDuplicateJSONData(availableSeeds)} // Options to display in the dropdown
                                          selectedValues={selectedSeed} // Preselected value to persist in dropdown
                                          onSelect={handleSeedChange} // Function will trigger on select event
                                          onRemove={handleSeedChange} // Function will trigger on remove event
                                          displayValue="name" // Property name to display in the dropdown options
                                          emptyRecordMsg="Aucune option trouvée"
                                          placeholder="Choisir une culture"
                                          style={{
                                            option: {  color: "black" },
                                            chips: { background: "#108758" },
                                            selected: { background: "#108758" },
                                          }}
                                          />
                          </div>
                        : null}
                        { filterProductTypeSelecter==='semence' ? 
                          <div className="creatbtn-redirect  ml-2 mr-2"  style={{ display:"inline-block" }}>
                                        <Multiselect
                                          options={seedVarietyDatas} // Options to display in the dropdown
                                          selectedValues={selectedSeedVariety} // Preselected value to persist in dropdown
                                          onSelect={handleSeedVarietyChange} // Function will trigger on select event
                                          onRemove={handleSeedVarietyChange} // Function will trigger on remove event
                                          displayValue="name" // Property name to display in the dropdown options
                                          emptyRecordMsg="Aucune option trouvée"
                                          placeholder="Choisir une culture"
                                          style={{
                                            option: {  color: "black" },
                                            chips: { background: "#108758" },
                                            selected: { background: "#108758" },
                                          }}
                                          />
                          </div>
                        : null}
                        { filterProductTypeSelecter==='intrant' ? 
                          <div className="creatbtn-redirect  ml-2 mr-2"  style={{ display:"inline-block" }}>
                                        <Multiselect
                                          options={fertilizerDatas} // Options to display in the dropdown
                                          selectedValues={selectedFertilizer} // Preselected value to persist in dropdown
                                          onSelect={handleFertilizerChange} // Function will trigger on select event
                                          onRemove={handleFertilizerChange} // Function will trigger on remove event
                                          displayValue="name" // Property name to display in the dropdown options
                                          emptyRecordMsg="Aucune option trouvée"
                                          placeholder="Choisir une culture"
                                          style={{
                                            option: {  color: "black" },
                                            chips: { background: "#108758" },
                                            selected: { background: "#108758" },
                                          }}
                                          />
                          </div>
                        : null}
                        { filterProductTypeSelecter==='phyto' ? 
                          <div className="creatbtn-redirect  ml-2 mr-2"  style={{ display:"inline-block" }}>
                                        <Multiselect
                                          options={phytoDatas} // Options to display in the dropdown
                                          selectedValues={selectedPhytoProduct} // Preselected value to persist in dropdown
                                          onSelect={handlePhytoProductChange} // Function will trigger on select event
                                          onRemove={handlePhytoProductChange} // Function will trigger on remove event
                                          displayValue="name" // Property name to display in the dropdown options
                                          emptyRecordMsg="Aucune option trouvée"
                                          placeholder="Choisir une culture"
                                          style={{
                                            option: {  color: "black" },
                                            chips: { background: "#108758" },
                                            selected: { background: "#108758" },
                                          }}
                                          />
                          </div>
                        : null}
                        <div className="creatbtn-redirect  ml-2 mr-2"  style={{ display:"inline-block" }}>
                                      <Multiselect
                                        options={removeDuplicateJSONData(availableFinalities)} // Options to display in the dropdown
                                        selectedValues={selectedFinality} // Preselected value to persist in dropdown
                                        onSelect={handleFinalityChange} // Function will trigger on select event
                                        onRemove={handleFinalityChange} // Function will trigger on remove event
                                        displayValue="type" // Property name to display in the dropdown options
                                        emptyRecordMsg="Aucune option trouvée"
                                        placeholder="Choisir une finalité"
                                        style={{
                                          option: {  color: "black" },
                                          chips: { background: "#108758" },
                                          selected: { background: "#108758" },
                                        }}
                                        />
                        </div>
                        </Box>: ""}
            </Box>
            {getFarmStockSheet(tabIndex) && getFarmStockSheet(tabIndex).length > 0 ? <TabPanel reference={refrence} value={tabIndex} style={{ maxWidth: resize===1 ? "1000px" : "100%",width: resize===1 ? "1000px" : "100%" }} index={activeFarm.id} />
              :  (getFarmStockSheet(tabIndex) && getFarmStockSheet(tabIndex).length <= 0 ? <NoStockOrNoCampaign /> : "")
              }
          </Box>
          <InitialStock
              visible={stockeInititationVisible}
              onCancel={() => {
                setStockeInititationVisible(false);
              }}
              onSuccess={() => {
                setStockeInititationVisible(false);
        }}
      />
        </div>
      </div>
    </>
  );
};

export default StockSheet;
